import {Component, OnInit, ViewChild } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {StsHttpService} from '../../../services/sts-http.service';
import {Question} from '../../../models/question.model';
import {QAndA} from '../../../models/q-and-a.model';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsErrorResponse} from '../../../models/sts-error-response';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsButtonComponent} from 'app/components/common/sts-button/sts-button.component';
import {StsConfigService} from '../../../services/sts-config.service';

@Component({
  selector: 'app-account-answer-questions',
  templateUrl: './account-answer-questions.component.html',
  styleUrls: ['./account-answer-questions.component.scss']
})
export class AccountAnswerQuestionsComponent implements OnInit {

  questions: Question[] = [];
  currentQAndA: QAndA[] = [];
  answerDirtyFlags: boolean[] = [];
  answerValid = true;
  currentLocale = 'en-CA';
  hasQuestions = false;
  noQuestionsFound = false;
  rotateSecurityQuestions = false;
  currentQuestionsIndex = 0;
  isDuring = true;
  tooManyInvalidResponses = false;
  quesAnswered = [];

  public errors: StsNotification[] = [];
  private userName: string;
  isPasswordRecoveryEmailSupported = false;

  @ViewChild(StsButtonComponent) submitButton;

  constructor(private http: StsHttpService,
              private router: Router,
              private config: StsConfigService,
              private tenantService: StsTenantService,
              private route: ActivatedRoute) {

  }

  isFrench() {
    return this.currentLocale && this.currentLocale.toLowerCase().includes('fr');
  }

  switchToEmail() {
    this.router.navigateByUrl('/account/forgot-password/email/' + this.userName);
  }

  ngOnInit() {

    this.tenantService.getTenantSource().subscribe(tenant => {
      this.currentLocale = tenant.currentLocale;
      this.rotateSecurityQuestions = tenant.rotateSecurityQuestions;
      this.isPasswordRecoveryEmailSupported = tenant.passwordRecoveryChoices.indexOf("Email") > -1;

      this.route.params.subscribe(params => {
        if (params['username']) {
          this.userName = params['username'];
          if (this.rotateSecurityQuestions) {
            this.getChallengeQuestionsByRotation();
          } else {
            this.getChallengeQuestions();
          }
        }
      });
    });
  }

  getChallengeQuestions() {
    this.http.get<Question[]>('/api/users/my/challengequestions?UserName='
    + this.userName
    , null,
    res => {
      let questions: Question[] = [];
      for (const resQuestion of res.preselectedQuestions) {
        let question = new Question();
        question.id = resQuestion.id;
        question.textEn = resQuestion.question.question['en-CA'] || resQuestion.question.question['en-US'];
        question.textFr = resQuestion.question.question['fr-CA'];
        questions.push(question);
      }
      this.hasQuestions = questions.length > 0;
      this.noQuestionsFound = !this.hasQuestions;
      // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
      return questions;
    }).subscribe(res => {
      this.questions = res;
      this.answerDirtyFlags = new Array(this.questions.length);
      console.log(this.questions);
      this.loadNextQuestion();
      // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
    },
    errorRes => {
      errorRes = this.mapError(errorRes);
      this.noQuestionsFound = true;
      this.handleError(errorRes);
      // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
    });
  console.log(this.userName);
  }

  getChallengeQuestionsByRotation() {
    let reqBody = { 'quesAnswered': this.quesAnswered };
    console.log('getchallengequestionsByRotation => ' + reqBody);
    this.http.post<Question[]>('/api/users/my/challengequestionsrotation?UserName='
    + this.userName
    , reqBody)
    .subscribe(res => {
      this.questions = res['preselectedQuestions'];
      let questions: Question[] = [];
      for (const resQuestion of res['preselectedQuestions']) {
        let question = new Question();
        question.id = resQuestion.id;
        question.textEn = resQuestion.question.question['en-CA'] || resQuestion.question.question['en-US'];
        question.textFr = resQuestion.question.question['fr-CA'];
        questions.push(question);
      }
      if (questions.length > 0) {
        let tmp = new QAndA();
        tmp.question = questions[0];
        this.currentQAndA.push(tmp);
      }
      this.hasQuestions = questions.length > 0;
      this.noQuestionsFound = !this.hasQuestions;
      this.answerDirtyFlags = new Array(this.questions.length);
      return questions;
    },
    errorRes => {
      errorRes = this.mapError(errorRes);
      this.noQuestionsFound = true;
      this.handleError(errorRes);
    });
  }

  isEntirelyValid(): boolean {
    if (this.rotateSecurityQuestions) {
      return this.questions.length > 0;
    } else {
      for (let i = 0; i < this.currentQAndA.length; i++) {
        if (!this.isAnswerValid(i)) { return false; }
      }
      return this.questions.length > 0;
    }
  }

  private isAnswerValid(i: number): boolean {
    let v = !!this.currentQAndA[i].answer;
    return v;
  }

  answerChanged(event, i) {
    this.answerDirtyFlags[i] = true;
    // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
  }

  onSubmit() {

    this.errors = [];

    if (!this.isEntirelyValid()) { return; }

    this.submitButton.onSubmit();
    let p = {Answers: []};
    for (let i = 0; i < this.currentQAndA.length; i++) {
      p.Answers.push({
        QuestionId: this.currentQAndA[i].question.id,
        Answer: this.currentQAndA[i].answer
      });
    }
    if (this.rotateSecurityQuestions) {
      for (const attemQues of this.questions) {
        const ques = attemQues['question'];
        if (this.quesAnswered.indexOf(ques.id) === -1) {
          this.quesAnswered.push(ques.id);
        }
      }
    }
    this.http.post('/api/users/passgrant/accessgrant?UserName=' + this.userName, p).subscribe(
        (res: any) => {
          this.errors = [];
          if (res.status === 'ok' &&
            res.grantAccessStatus &&
            res.grantAccessStatus.toLowerCase() === 'success') {
            let url = '/account/password/new';
            this.router.navigateByUrl(url);
            // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          } else if (res.verificationStatus.toLowerCase() === 'locked' ) {
            this.tooManyInvalidResponses = true;
            // this.router.navigateByUrl('/account/help');
            let err = new StsNotification();
            err.code = 'sts-too-many-invalid-response';
            err.description = 'Sorry you have exceeded maximum number of questions';
            err.level = StsNotificationType.Error;
            this.errors.push(err);
            this.isDuring = false;
            // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          } else {
            let err = new StsNotification();
            err.code = 'sts-invalid-response';
            err.description = 'Please try again';
            err.level = StsNotificationType.Error;
            this.errors.push(err);
            this.loadNextQuestion();
            this.submitButton.onSubmitFinished();
            // try { this.ref.detectChanges(); } catch(ex) { console.log(ex); }
          }
        }, errorRes => {
          this.errors = [];
          errorRes = this.mapError(errorRes);
          this.handleError(errorRes);
          this.submitButton.onSubmitFinished();
        });
  }

  onContinue() {
    window.location.href = '/';
  }

  private loadNextQuestion() {

    this.currentQAndA = [];

    if (this.rotateSecurityQuestions) {
        this.getChallengeQuestionsByRotation();
    } else {
      for (let i = 0; i < this.questions.length; i++) {
        let tmp = new QAndA();
        tmp.question = this.questions[i];
        this.currentQAndA.push(tmp);
      }
    }
  }

  private mapError(data): StsErrorResponse {
    let rsp = data._body ? JSON.parse(data._body) : data;
    let response = new StsErrorResponse();
    response.message = rsp.message;
    response.status = data.status;
    response.stsCode = this.normalizeCode(rsp['sts-code'] || '');
    response.error = rsp.error;
    return response;
  }


  private handleError(data) {
    console.log(data);
    if (data.error && data.error.errors && data.error.errors.length) {
      for (let i = 0; i < data.error.errors.length; i++) {
        let err = new StsNotification();
        let e = data.error.errors[i];
        err.code = this.normalizeCode(e.errorCode + ' ' + e.explanation);
        err.description = e.explanation;
        err.level = StsNotificationType.Error;
        this.errors.push(err);
      }
    } else {
      let err = new StsNotification();
      err.code = this.normalizeCode(data.stsCode || 'sts-reset-pass-message');
      err.description = data.message || data.stsCode || 'Error';
      err.level = StsNotificationType.Error;
      this.errors.push(err);
    }
  }

  private normalizeCode(c: string): string {
    c = (c || '').replace(/[_ ]/g, '-').toLowerCase();
    if (c.indexOf('sts-') === -1) { c = 'sts-' + c; }
    return c;
  }

}
